// @flow

import _ from 'lodash';
import { createSelector, defaultMemoize } from 'reselect';

import nodes from 'app/get-help/content/nodes';
import { MAX_SERVICE_LINKS_TO_DISPLAY } from 'app/get-help/constants';
import { isHidden } from 'app/service/ServiceUtils';
import { selectNodesInPath } from 'app/get-help/utils/tree';

import type { ZapType } from '@zapier/product-get-help';

import type { DataSet, SelectedNode } from 'app/get-help/utils/tree/types';
import type { ServicesMap } from 'app/service/types';
import type { State } from 'app/common/types';

const EMPTY_ARRAY = [];

export const selectServices = (
  state: State,
  props: { services: ServicesMap }
) => {
  return props.services || {};
};

export const selectZapServices = (zap?: ZapType, services: ServicesMap) => {
  if (!zap || zap.nodes.length === 0 || !Object.keys(services).length) {
    return EMPTY_ARRAY;
  }

  return zap.nodes
    .reduce((selectedServices, { selectedApi }) => {
      if (selectedApi) {
        const service = _.get(services, [selectedApi], {});
        const slug = _.get(service, ['slug']);
        const name = _.get(service, ['name']);
        const isPublic = _.get(service, ['isPublic']);
        if (slug && name && isPublic) {
          selectedServices.push({
            id: selectedApi,
            name,
            slug,
          });
        }
      }
      return selectedServices;
    }, [])
    .slice(0, MAX_SERVICE_LINKS_TO_DISPLAY);
};

export const selectVisibleServicesOrdered = createSelector(
  // not using getVisibleServices because that wants a map :(
  services => services.filter(service => !isHidden(service)),
  services =>
    services.sort((a, b) => {
      if (a.isPublic === b.isPublic) {
        return (a.name || a.key || '').localeCompare(b.name || b.key || '');
      }
      return a.isPublic ? 1 : -1;
    })
);

export const selectNodes = (defaultMemoize((meta, dataSet) =>
  selectNodesInPath(nodes, meta, dataSet)
): (meta: DataSet, dataSet: DataSet) => SelectedNode[]);

export const selectAttemptId = (state: State): ?number =>
  _.get(state, ['get-help', 'attemptId']);
